import cn from 'classnames';
import React from 'react';

export function withLabel(CheckboxRadio) {
    return React.forwardRef(function CheckboxRadioButton(
        {
            checkboxClassName,
            className,
            id,
            isError,
            label,
            labelClassName,
            labelStyle,
            radioClassName,
            style,
            ...props
        },
        ref,
    ) {
        const seleniumId = props['data-seleniumid'];

        return (
            <label
                className={cn('selection', className, {
                    'selection--checked': props.checked,
                    'selection--error': isError,
                    'selection--logo-outer': !!props.logo,
                })}
                htmlFor={id}
                style={style}
            >
                <CheckboxRadio
                    ref={ref}
                    {...props}
                    className={cn('selection-ctrl', radioClassName, checkboxClassName)}
                    id={id}
                    isError={isError}
                />
                {typeof label === 'string' ? (
                    <div
                        className={cn('selection-label', labelClassName, { text_bold: props.checked })}
                        dangerouslySetInnerHTML={{ __html: label }}
                        data-seleniumid={`${seleniumId}-label`}
                        style={labelStyle}
                    />
                ) : (
                    <div
                        className={cn('selection-label', labelClassName, { text_bold: props.checked })}
                        data-seleniumid={`${seleniumId}-label`}
                        style={labelStyle}
                    >
                        {label}
                    </div>
                )}
                {!!props.logo && (
                    <div className={cn('selection-logo')} style={{ flexWrap: 'wrap' }}>
                        {props.logo}
                    </div>
                )}
            </label>
        );
    });
}

export default { withLabel };
